<template>
    <!-- Prescription (Rx) mark inside a magnifying glass: "prescription monitoring".
         Stroke-based and monochrome so it inherits AppButton's .draw-border color
         (#003300 at rest, #0a8927 on hover) via currentColor. -->
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
        fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
        <!-- lens -->
        <circle class="ahs-vdh-vpms-svg" cx="208" cy="208" r="150" stroke-width="34" />
        <!-- handle -->
        <path class="ahs-vdh-vpms-svg" d="M314 314 L452 452" stroke-width="44" />
        <!-- R stem -->
        <path class="ahs-vdh-vpms-svg" d="M158 142 V272" stroke-width="24" />
        <!-- R bowl -->
        <path class="ahs-vdh-vpms-svg" d="M158 142 H198 a34 34 0 0 1 0 68 H158" stroke-width="24" />
        <!-- R leg -->
        <path class="ahs-vdh-vpms-svg" d="M186 210 L232 272" stroke-width="24" />
        <!-- x -->
        <path class="ahs-vdh-vpms-svg" d="M246 214 L290 268" stroke-width="22" />
        <path class="ahs-vdh-vpms-svg" d="M290 214 L246 268" stroke-width="22" />
    </svg>
</template>

<script>
export default {
    name: 'ahsVdhVpmsLogo',
}
</script>

<style scoped>
svg {
    transition: stroke .2s ease;
}
</style>
